<template>
  <div class="form-group">
    <label :key="`checked-${clientMounted}`"
           :class="{ 'radio--checked': checked }"
           class="radio"
    >
      <input v-taptic="'selection'"
             type="radio"
             :name="name"
             :checked="checked"
             :data-test-id="dataTestId"
             @click="setSortingKey()"
      >
      <slot><!--Radio label text--></slot>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue"
import { useMarketplaceStore } from "@/stores/ssr/useMarketplaceStore"
import { MarketplaceSortingKey } from "@/enums/MarketplaceSortingKey"

const marketplaceStore = useMarketplaceStore()

const props = withDefaults(defineProps<{
  name: string,
  value: MarketplaceSortingKey,
  dataTestId?: string,
}>(), {
  dataTestId: null,
})

const clientMounted = ref<boolean>(false)

const checked = computed(() => marketplaceStore.sortingKey === props.value)

onMounted(() => {
  clientMounted.value = true
})

const setSortingKey = () => {
  marketplaceStore.setSortingKey(props.value)
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/styling.scss";
@import "@/assets/css/mixins/interactions.scss";

.radio {
  display:    flex;
  align-items: center;
  transition: color 110ms ease-out;

  &--checked {
    font-weight: 700;
    color:      var(--color-brand-primary);
    transition: color 110ms ease-out;
  }

  [type="radio"] {
    width:         1.25rem;
    height:        1.25rem;
    border:        1px solid var(--color-neutral-tertiary);
    border-radius: 50%;
    margin-right:  0.75rem;
    display:       flex;
    align-items:   center;
    justify-content: center;
    transition:    border 150ms ease-out;

    &:after {
      @include gradient-button;
      display:    block;
      width:      0.75rem;
      height:     0.75rem;
      border-radius: 50%;
      content:    "";
      opacity:    0;
      transition: opacity 110ms ease-out;
    }

    &:checked {
      border: 1px solid var(--color-brand-primary);

      &:after {
        opacity: 1;
        transition: opacity 110ms ease-out;
      }
    }
  }

  @include hover {
    &:hover {
      cursor: pointer;

      [type="radio"] {
        border: 1px solid var(--color-brand-primary);
        transition: border 150ms ease-out;
      }
    }
  }
}

.form-group {
  display: flex;
  align-items: center;
}
</style>
